export const pillars = ['Épaule', 'Genou', 'Cheville', 'Colonne', 'Hanche', 'Coude'];
export const volumes = [{
  n: 1,
  emoji: '📘',
  title: "L'Épaule Explosive (The Shoulder Blueprint)",
  desc: "Comprenez la mécanique de l'épaule étape par étape. Évaluez, réhabilitez et ramenez vos athlètes aux mouvements de poussée avec assurance."
}, {
  n: 2,
  emoji: '📗',
  title: 'Le Genou de Fer (The Knee Fortress)',
  desc: 'Gérez les blessures du LCA, du LCM et du tendon patellaire avec des protocoles de charge progressive. Évitez les erreurs classiques de prescription.'
}, {
  n: 3,
  emoji: '📙',
  title: 'La Cheville Résiliente (The Ankle Command)',
  desc: "Incorporez les protocoles d'entorse, la hiérarchie de reprogrammation proprioceptive et les critères de retour à la course utilisés dans le sport d'élite."
}, {
  n: 4,
  emoji: '📕',
  title: 'Le Bouclier Lombaire (The Spine Shield)',
  desc: 'Un cadre organisé pour gérer les lombalgies et les hernies discales avec des critères de progression clairs pour avancer sans se perdre.'
}, {
  n: 5,
  emoji: '📓',
  title: 'Le Moteur de la Hanche (The Hip Engine)',
  desc: 'Maîtrisez la mobilité de hanche, l\'activation des fessiers et la stabilité pelvienne pour construire des protocoles sans hésitation.'
}, {
  n: 6,
  emoji: '📔',
  title: 'Bras et Poignet (Upper Limb Recovery)',
  desc: 'Prenez des décisions cliniques réelles pour les épicondylites et le canal carpien. Mettez en place votre premier protocole sans douter de vos progressions.'
}];
export const volumeIncludes = ['Protocoles visuels étape par étape', "Critères d'évaluation clinique", 'Points de contrôle de progression', 'Exemples réels de retour au sport', 'Checklists quotidiennes de pratique', 'Fiches de suivi imprimables'];
export const bonuses = [{
  n: '01',
  title: "L'Encyclopédie M.A.P.A.™",
  desc: 'Protocoles de mobilité complets pour activer toutes les articulations et construire des schémas de mouvement fonctionnels.',
  price: '27 €',
  cover: 'https://cdn.magicpatterns.com/uploads/6BDVjXVJS2RBLmUb4s9Gi5/ChatGPT_Image_22_sept_2026,_17_00_20.png'
}, {
  n: '02',
  title: 'Récupération Zéro Équipement™',
  desc: 'Gérez une rééducation complète à domicile en utilisant uniquement le poids du corps et des objets du quotidien.',
  price: '25 €',
  cover: 'https://cdn.magicpatterns.com/uploads/tJDtJZka7GjALcDehYButK/ChatGPT_Image_22_sept_2026,_17_00_25.png'
}, {
  n: '03',
  title: 'Le Protocole Load Master™',
  desc: 'Protocoles en salle de sport pour appliquer le travail sur machines, haltères et barres avec des critères de charge précis.',
  price: '22 €',
  cover: 'https://cdn.magicpatterns.com/uploads/gDQjwTiJ9EtxQPX8eQCSJL/ChatGPT_Image_22_sept_2026,_17_00_27.png'
}, {
  n: '04',
  title: 'Système A.R.M.A.™',
  desc: 'Système de maintenance permanent (Évaluation, Résilience, Maintenance, Action) pour éviter toute rechute.',
  price: '19 €',
  cover: 'https://cdn.magicpatterns.com/uploads/h6kKorrNHwQG61QQuMkyrq/ChatGPT_Image_22_sept_2026,_17_01_02.png'
}, {
  n: '05',
  title: 'Performance Warm-up Matrix™',
  desc: 'Routines spécifiques pour coureurs, tennismen et un protocole « Bureau » pour réactiver la chaîne postérieure après 8h assis.',
  price: '25 €',
  cover: 'https://cdn.magicpatterns.com/uploads/rYJN8Eq5KRguTuJbiVQxTg/ChatGPT_Image_22_sept_2026,_17_01_07.png'
}];
